import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SportPanelSectionImpl from './sport-panel-section.js';

const { UIView } = MojitoCore.Presentation;

/**
 * A single expandable sport inside the search discovery sports list. When expanded it shows a link
 * to the full sport offer followed by the top and all competitions of that sport. The header also
 * holds a star toggling the sport in the {@link Mojito.Modules.SportsMenu|sports menu} favorites.
 *
 * @class SportPanelSection
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SportPanelSection` prop types.
 *
 * @property {object} sport - Sport to render. Expects at least an `id` and a `name`.
 * @property {boolean} [isFavoriteSport = false] - Whether the sport is currently favorited.
 * @property {boolean} [expanded = false] - Flag controlling whether the sport contents are shown.
 * @property {string} [competitionsGroupId] - Container id holding all competitions of the sport. Typically resolved from the sports menu content.
 * @property {Function} onToggle - Called when the sport header is clicked.
 * @property {Function} [onNavigate] - Called after the user triggers navigation from within the section.
 *
 * @memberof Mojito.Applications.Sports.Search.SportPanelSection
 */
const propTypes = {
    sport: PropTypes.object.isRequired,
    isFavoriteSport: PropTypes.bool,
    expanded: PropTypes.bool,
    competitionsGroupId: PropTypes.string,
    onToggle: PropTypes.func.isRequired,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    isFavoriteSport: false,
    expanded: false,
    onNavigate: noop,
};

export default UIView('SportPanelSection', SportPanelSectionImpl, propTypes, defaultProps);
